import { render, staticRenderFns } from "./ZoomSelecProdutorVisita.vue?vue&type=template&id=507f2252&"
import script from "./ZoomSelecProdutorVisita.vue?vue&type=script&lang=js&"
export * from "./ZoomSelecProdutorVisita.vue?vue&type=script&lang=js&"
import style0 from "./ZoomSelecProdutorVisita.vue?vue&type=style&index=0&id=507f2252&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports